import { render } from "./ProcessDispatch.vue?vue&type=template&id=14d05138&scoped=true"
import script from "./ProcessDispatch.vue?vue&type=script&lang=js"
export * from "./ProcessDispatch.vue?vue&type=script&lang=js"

import "./ProcessDispatch.vue?vue&type=style&index=0&id=14d05138&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d05138"]])

export default __exports__